import {useState, useEffect, cloneElement} from 'react';
import { db, auth } from '../firebase';
import {addDoc, collection, doc, getDocs, deleteDoc, where, query} from "firebase/firestore";
import {onAuthStateChanged} from "firebase/auth";
import {useHistory} from "react-router-dom";
import cartPic from "../img/cart.png";
export default function Cart({isUser}) {

    const [cartItems, setCartItems] = useState();
    const [user, setUser] = useState();
    const [total, setTotal] = useState(0);
    const [count, setCount] = useState(0);
    const history = useHistory();

    const [empty, setEmpty] = useState(false);

    onAuthStateChanged(auth, (user) => {
      if(user){
        setUser(user.uid);
      }
    })

    async function handleOrder(){
      addDoc(collection(db, `users/${user}/orders`), {
        cart: cartItems,
        id: Number(count)
      })

      getDocs(collection(db, `users/${user}/cart`)).then((snap) => {
        snap.forEach((item) => {
          deleteDoc(item.ref).then(() => {
            alert("Your Order Has Been Placed ❤")
            history.push("/");
          })
        })
      })
    };

    useEffect(() => {
        function fetchAll(){
          const cartDetails = [];
          if(user){
            getDocs(collection(db, `users/${user}/cart`)).then((snap) => {
              if(snap.empty){
                setEmpty(true);
              }
              else{
                snap.forEach((item) => {
                  cartDetails.push(item.data());
                })
              }
              setCartItems(cartDetails);
              cartDetails.map((item) => {
                setTotal(prev => prev += Number(item.totalAmount))
              })
              setCount(cartDetails.length + 1);
            }) 
          }
        }
        fetchAll();

    }, [user])

    if(cartItems){
      if(!cartItems.length > 1){
        return null;
      }
    }

  return (
    <div className='cart-page'>
      <h2 className='heading'>Cart Items</h2>
      <>{empty ? <div className='cart-empty'><img src = {cartPic}/><p>Your Cart Is Empty</p></div> : cartItems && <div className='cart-listings'>
        <div className='cart-list-top'>
          <p>Item Img</p>
          <p>Item Name</p>
          <p>Item Amount</p>
          <p>Item Price</p>
          <p>Total Price</p>
          <p>--------</p>
        </div>
        {cartItems.map((item) => {
          return <div className='cart-item' key={item.id}>
            <p><img src = {item.itemImg}/></p>
            <p>{item.itemName}</p>
            <p>{item.itemAmount}</p>
            <p>{item.itemPrice}</p>
            <p>₦ {item.totalAmount}</p>
            <p><button onClick={(async() => {
              const q = query(collection(db, `users/${user}/cart`), where("id", "==", item.id));
              const querySnap = await getDocs(q);
              querySnap.forEach(async(item) => {
                deleteDoc(item.ref).then(() => {
                  alert("Item Deleted Successfully")
                  window.location.reload();
                })
              })

            })}>Delete</button></p>
          </div>
        })}
        <div className='cart-total'><p>Total = ₦ {total}</p><button onClick={handleOrder}>Order</button></div>
      </div>}</>
      
    </div>
  )
}